export enum ScanType {
    unknown = 0,
    pickup = 1,
    delivery = 2
}